export const logInConstants = {
  LOGIN_IN:"LOGIN_IN",
  USER_TYPE: "USER_TYPE",
  LOG_OUT_USER: "LOG_OUT_USER",
  GET_USER_FROM_LOCAL: "GET_USER_LOCAL",
  SET_ERROR:"SET_ERROR",
  SET_LOADER: "SET_LOADER",
  SET_USER_FROM_LOCAL:"SET_USER_FROM_LOCAL",
}